import { create } from "zustand";
import { persist } from "zustand/middleware";
import { Training } from "../training/entities/Training";
interface TrainingStore {
  trainings: Training[];
  current: Training | null;
  setTrainings: (trainings: Training[]) => void;
  setCurrent: (training: Training) => void;
}

export const useTrainingStore = create<TrainingStore>()(
  persist(
    (set) => ({
      trainings: [],
      current: null,
      setTrainings: (trainings) =>
        set((state) => ({
          trainings,
          current: state.current ?? trainings[0] ?? null,
        })),
      setCurrent: (training) => set({ current: training }),
    }),
    {
      name: "trainings-storage",
    },
  ),
);
